import React, { useState } from "react";
import { Grid, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { RadioButton } from "@progress/kendo-react-inputs";

const ClientWizardComplete = (props) => {
  const [state, setState] = useState({
    addMoreParticipants: false,
  });

  const onChange = (e) => {
    setState({
      ...state,
      addMoreParticipants: e.value === "yes",
    });
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={8}>
        &nbsp;
      </Grid>
      <Grid item xs={4}>
        <div className={"client-wizard-buttons"}>
          <Button
            color={"secondary"}
            variant={"contained"}
            onClick={() => {
              if (state.addMoreParticipants) {
                props.resetToAddParticipants();
                return;
              }
              props.completeWizard();
            }}
          >
            Save
          </Button>
        </div>
      </Grid>
      <Grid className={"completed-check"} item xs={2}>
        <CheckCircleIcon />
      </Grid>
      <Grid item xs={10}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography component={"h2"} variant={"h2"}>The new client wizard has been completed.</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography component={"label"} variant={"label"}>
                Want to add more participants to the client record?
              </Typography>
            </Grid>
          <Grid className={"radio-button-cell"} item xs={1}>
            <RadioButton
              label={"Yes"}
              value={"yes"}
              checked={state.addMoreParticipants}
              onChange={onChange}
            />
          </Grid>
          <Grid className={"radio-button-cell"} item xs={1}>
            <RadioButton
              label={"No"}
              value={"no"}
              checked={!state.addMoreParticipants}
              onChange={onChange}
            />
          </Grid>
        </Grid>
      </Grid>
    
    </Grid>
  );
};

export default ClientWizardComplete;
